import React, { useRef, useState, useEffect } from "react";
import { Box, Text } from "@chakra-ui/react";
import { PricingTable } from "./table";
import { type PricingTablesProps } from "./data";
import { TABLE_HEAD_WIDTH } from "./utils";

export function TableGroup({
  isFirst,
  headingWidth,
  heading,
  tables,
}: PricingTablesProps & { isFirst?: boolean; headingWidth: number }) {
  const groupTitle = useRef<HTMLDivElement>(null);
  const [groupTitleHeight, setGroupTitleHeight] = useState(0);

  useEffect(() => {
    const groupTitleObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setGroupTitleHeight(entry.contentRect.height);
      }
    });

    if (groupTitle.current) {
      groupTitleObserver.observe(groupTitle.current);
    }

    return () => {
      groupTitleObserver.disconnect();
    };
  }, [groupTitleHeight]);

  return (
    <Box>
      <Box ref={groupTitle} flex={1} w={headingWidth} maxW={TABLE_HEAD_WIDTH}>
        <Text
          as="h3"
          textStyle="uppercase"
          fontSize="lg"
          p={3}
          pt={isFirst ? 3 : 12}
          pos="relative"
          // Bottom border
          _before={{
            content: "''",
            pos: "absolute",
            bottom: 0,
            left: 0,
            right: { base: 12, xl: 16 },
            height: "1px",
            bg: "new.gray.150",
          }}
        >
          {heading}
        </Text>
      </Box>

      {tables.map((table, index) => {
        return (
          <PricingTable
            key={table.tableTitle ?? heading}
            groupTitle={heading}
            title={table.tableTitle}
            isFirst={index === 0}
            extendedBorderHeight={groupTitleHeight}
            {...table}
          />
        );
      })}
    </Box>
  );
}
